// extracted by mini-css-extract-plugin
export var date = "Number-module--date--2aede";
export var el = "Number-module--el--5a6ef";
export var host = "Number-module--host--3d73e";
export var number = "Number-module--number--82775";